import { Mui } from "@osu/react-ui";
import { Fragment, useState } from "react";
import Preview from "./Preview";

function TextField({ name, id: _id, ...rest }) {
  const [message, setMessage] = useState();
  const id = _id || "system-message-input";
  const inputLabelId = id + "-name";

  return (
    <Fragment>
      <Mui.FormGroup sx={{ width: '100%' }}>
        <Mui.Typography
          variant="body1"
          component={Mui.FormLabel}
          id={inputLabelId}
        >
          System Alert Message
        </Mui.Typography>
        <Mui.TextField
          {...rest}
          minRows={2}
          multiline
          name={name}
          aria-labelledby={inputLabelId}
          value={message}
          onChange={(event) => {
            setMessage(event.target.value);
          }}
          placeholder="Write a brief sentence, this will appear as an info alert for all users and will persist until it is cleared."
        />
      </Mui.FormGroup>
      <Preview message={message} />
    </Fragment>
  );
}

export default TextField;
